import { DialogButtonTypesEnum, DialogConfigInterface } from 'appShared/components';

/**
 * Dialog config for the Deactivate Feeds/Bundles dialog (CRM-5195). Mirrors the
 * existing create/edit subscription dialog configs. The Confirm button carries
 * the "Deactivate" label and is toggled hidden/disabled by the dialog component
 * based on selection and date validity.
 */
export const DeactivateSubscriptionDialogConfig = (): DialogConfigInterface => {
    return {
        process: {
            loading: false,
            finished: false,
            failed: false,
            failedMessage: '',
            succeedMessage: ''
        },
        buttons: [
            {
                type: DialogButtonTypesEnum.Cancel
            },
            {
                type: DialogButtonTypesEnum.Confirm,
                customText: 'Deactivate',
                disabled: false,
                hidden: false
            }
        ],
        buttonsDisabled: false,
        buttonsHidden: false,
        disabledCloseBtn: true
    };
};
